import {useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { AuthContext } from '../../Auth/AuthContext';
import usePeriodos from './obtienePeriodos';
import './styles.css';

const API_URL = 'https://ghost-main-static-b7ec98c880a54ad5a4782393902a32a2.ghostapi.app:29003/api/ghost/v1/accounts/invoiceretrieve/customersearch';

const CreaPeriodo = () => {
   const {periodos, refetchPeriodos } = usePeriodos();
  // Contexto y estados para facturas
  const { token } = useContext(AuthContext);
  const [invoices, setInvoices] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [valorTotal, setValorTotal] = useState(0); // Estado para el valor de la factura seleccionada
  const [associations, setAssociations] = useState({});
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState('2025-01-01');
  const [toDate, setToDate] = useState('2025-02-27');
  const [periodo, setPeriodo] = useState('');
  
  // Estados para el manejo de modales
  const [modalVisible, setModalVisible] = useState(false); // Modal para asociar facturas externas
  const [modalFacturasGhost, setModalFacturasGhost] = useState(false); // Modal para ver facturas y buscar
  const [externalInvoiceNumbers, setExternalInvoiceNumbers] = useState({});

  // Función para obtener las facturas
    const fetchInvoices = useCallback(async () => {
      setLoading(true);
      try {
        const body = {
          from: new Date(fromDate).toISOString(),
          to: new Date(toDate).toISOString(),
          invoicingAccountType: 'Standard',
          accountId: null,
          invoiceNumber: null,
          companyId: null,
          companyIds: [],
        };

        const response = await axios.post(`${API_URL}?pageno=1&pagesize=1000`, body, {
          headers: {
            'Content-Type': 'application/json',
            'Authentication-Token': token,
          },
        });

        setInvoices(response.data.invoices || []);
        console.log('Facturas obtenidas:', response.data.invoices);
        setSelectedIds([]);
        setAssociations({});
      } catch (error) {
        console.error('Error fetching invoices:', error);
        alert('Error al obtener las facturas');
      } finally {
        setLoading(false);
      }
    }, [fromDate, toDate, token]);

  // Función para obtener el nombre del período a partir de la fecha
  const obtenerNombrePeriodo = (valor) => {
  const [anio, mes] = valor.split('-');
  const nombreMes = new Date(mes).toLocaleString('es-ES', { month: 'long' });
  return `${nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1)} ${anio}`;
};

// Función para crear un nuevo período
  const handleChange = (e) => {
    // El formato será "YYYY-MM"
    const nombrePeriodo = obtenerNombrePeriodo(e.target.value);
    setPeriodo(nombrePeriodo);
  };

  const crearNuevoPeriodo = async () => {
    try {
     
         if (selectedIds.length === 0 ) {
            alert('Selecciona al menos una factura');
            return;
         }

        if (!periodo) {
            alert('debe seleccionar un nombre del nuevo periodo');
            return;
         }

      // Crear el payload para la API
        const payload = {
          nombre: periodo,
          facturas: selectedIds.map((id) => {
            const invoice = invoices.find((inv) => inv.id === id);
            const rawDate = invoice?.invoiceDate;

            // Convertir a formato "YYYY-MM-DD HH:MM:SS"
            const fechaMysql = rawDate
              ? new Date(rawDate).toISOString().slice(0, 19).replace('T', ' ')
              : null;

            return {
              id: id,
              fecha: fechaMysql,
              numeroFactura: invoice?.invoiceNumber,
              cliente: invoice?.customerName,
              totalNeto: invoice?.totalNet,
              // servicios: invoice?.numberOfJobs,
            };
          }),
        };
      const response = await axios.post('https://intranet.ecotranschile.cl/softland/nuevoPeriodo.php',payload,
        {
          headers: {
             'Content-Type': 'application/json; charset=utf-8',
          },
        }
      );

      console.log('Respuesta del servidor:', response.data);
      await refetchPeriodos();

         if (response.data) {
            alert('Periodo creado exitosamente');
            setModalFacturasGhost(false);
            return;
         }

    } catch (error) {
      console.error('Error al crear nuevo periodo:', error);
    }
  };

  // Efecto para cargar facturas al tener el token
  useEffect(() => {
    if (!token) return;
    fetchInvoices();
  }, [token, fetchInvoices]);

  // Función para seleccionar facturas
  const handleSelect = (id, valor) => {
    setSelectedIds((prev) => {
      if (prev.includes(id)) {
        // Deseleccionado: quitar ID y restar valor
        setValorTotal((v) => v - valor);
        return prev.filter((sid) => sid !== id);
      } else {
        // Seleccionado: agregar ID y sumar valor
        setValorTotal((v) => v + valor);
        return [...prev, id];
      }
    });
  };

  // Modal para asociar facturas externas
  // const handleOpenModal = () => {
  //   if (selectedIds.length === 0) {
  //     alert('Selecciona al menos una factura');
  //     return;
  //   }
  //   setModalVisible(true);
  //   setExternalInvoiceNumbers(() => {
  //     const newExternalInvoiceNumbers = {};
  //     selectedIds.forEach((id) => {
  //       newExternalInvoiceNumbers[id] = ['']; // Iniciamos con un campo vacío por cada factura seleccionada
  //     });
  //     return newExternalInvoiceNumbers;
  //   });
  // };

  const handleModalClose = () => {
    setModalVisible(false);
  };

  const handleOpenModalFacturasGhost = () => {
    setPeriodo(''); // Limpiamos el nombre del periodo
    setSelectedIds([]); // limpiamos el checkbox para que no se mantengan seleccionadas las facturas
    setModalFacturasGhost(true);
  };

  const handleCloseModalFacturasGhost = () => {
    setModalFacturasGhost(false);
  };

  const handleExternalInvoiceChange = (id, index, value) => {
    const newNumbers = { ...externalInvoiceNumbers };
    newNumbers[id][index] = value;
    setExternalInvoiceNumbers(newNumbers);
  };

  const handleAddExternalInvoiceField = (id) => {
    const newNumbers = { ...externalInvoiceNumbers };
    newNumbers[id].push(''); // Añadimos un nuevo campo
    setExternalInvoiceNumbers(newNumbers);
  };

  const handleRemoveExternalInvoiceField = (id, index) => {
    const newNumbers = { ...externalInvoiceNumbers };
    newNumbers[id].splice(index, 1);
    setExternalInvoiceNumbers(newNumbers);
  };

  // Función para asociar facturas a una factura interna
  const handleAssociateInvoices = () => {
    const newAssociations = { ...associations };
    selectedIds.forEach((id) => {
      newAssociations[id] = externalInvoiceNumbers[id];
    });
    setAssociations(newAssociations);
    setModalVisible(false); // Cerrar modal de asociación
  };

  return (
    <div className="container">
      <div className="header">
        <h2>cierres</h2>
        <button className="new-period-button" onClick={handleOpenModalFacturasGhost}>
          nuevo periodo
        </button>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th className="table-header">Nombre periodo</th>
            <th className="table-header">Cantidad Facturas</th>
            <th className="table-header">Total </th>
            <th className="table-header right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {/* mapeando los periodos obtenidos desde la API  */}
          {periodos.map((period) => (
            <tr key={period.idPeriodo}>
              <td>{period.nomPeriodo}</td>
              <td>{period.cantidad_facturas}</td>
              <td>
                {new Intl.NumberFormat('es-CL', {
                  style: 'currency',
                  currency: 'CLP',
                }).format(period.total_facturas)}
              </td>
              <td className="right">
                <button
                  onClick={() => alert(`Agregando facturas al período ${period.nomPeriodo}`)}
                  className="agregar-button"
                >
                  agregar
                </button>
                <button
                  onClick={() => alert(`Editando período ${period.nomPeriodo}`)}
                  className="agregar-button"
                >
                  Editar periodo
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalFacturasGhost && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
                <div className="actions">
                  <button onClick={handleCloseModalFacturasGhost}>X</button>
              </div>
            <h2>Nuevo Periodo de Cierre</h2><input type="month" onChange={handleChange} />
            <h2>Facturas listadas </h2>
            <div style={{ marginBottom: '1rem' }}>
              <label>Desde: </label>
              <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
              <label style={{ marginLeft: '1rem' }}>Hasta: </label>
              <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
              <button onClick={fetchInvoices} style={{ marginLeft: '1rem' }}>
                Buscar
              </button>
            </div>

            <div className="actions">
                <button onClick={crearNuevoPeriodo} style={{ marginBottom: '1rem' } }>
                  GENERAR NUEVO PERIODO
                </button>
                {/* detalle de totales seleccionados */}
                <p>
                  Total: {invoices.length} — Seleccionadas: {selectedIds.length} — 
                  Total Valor: {valorTotal.toLocaleString('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                  })}
                </p>
            </div>


          </div>
            {loading ? (
              <p>Cargando...</p>
            ) : (
              <>
                <table border="1" cellPadding="8" cellSpacing="0" style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Check</th>
                      
                      <th>N° Factura</th>
                      <th>Cliente</th>
                      <th>Fecha</th>
                      <th>Total </th>
                      <th>Servicios</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((invoice) => (
                      <tr
                        key={invoice.id}
                        className={selectedIds.includes(invoice.id) ? 'invoice-row-selected' : ''}
                      >
                        <td>
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(invoice.id)}
                            onChange={() => handleSelect(invoice.id, invoice.totalNet)}
                          />
                        </td>
                       
                        <td>{invoice.invoiceNumber}</td>
                        <td>{invoice.customerName}</td>
                        <td>{new Date(invoice.invoiceDate).toLocaleDateString()}</td>
                        <td>${invoice.totalNet.toLocaleString()}</td>
                        <td>{invoice.numberOfJobs}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}

          </div>
        </div>
      )}
    {/* modal para asociar facturas desde softland  aun no implementado */}
      {modalVisible && (
        <div className="modal-overlay">
          <div className="modal-content modal-content-narrow">
            <h3>Asociar Facturas Externas</h3>
            <table border="1" cellPadding="8" cellSpacing="0" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th>ID Factura</th>
                  <th>N° Factura Externa</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {selectedIds.map((id) => (
                  <tr key={id}>
                    <td>{id}</td>
                    <td>
                      {externalInvoiceNumbers[id].map((num, index) => (
                        <div key={index}>
                          <input
                            type="text"
                            value={num}
                            onChange={(e) =>
                              handleExternalInvoiceChange(id, index, e.target.value)
                            }
                            placeholder="Número de factura externa"
                          />
                          <button onClick={() => handleRemoveExternalInvoiceField(id, index)}>
                            Eliminar
                          </button>
                        </div>
                      ))}
                      <button onClick={() => handleAddExternalInvoiceField(id)}>
                        Agregar Factura Externa
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="actions">
              <button onClick={handleAssociateInvoices} style={{ marginRight: '1rem' }}>
                Asociar
              </button>
              <button onClick={handleModalClose}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CreaPeriodo;
